export const PIPELINE = [
  { k: "researching", label: "Researching" },
  { k: "ready", label: "Ready to contact" },
  { k: "outreach_sent", label: "Outreach sent" },
  { k: "waiting", label: "Waiting" },
  { k: "dialogue", label: "Dialogue" },
  { k: "interested", label: "Interested" },
  { k: "confirmed", label: "Confirmed" },
  { k: "declined", label: "Declined" },
];
export const STAGE_LABEL = Object.fromEntries(PIPELINE.map((s) => [s.k, s.label]));
export const STAGE_INDEX = Object.fromEntries(PIPELINE.map((s, i) => [s.k, i]));

export const stageFarge = (k) => {
  const i = STAGE_INDEX[k] ?? 0;
  if (k === "declined") return "#DC2626";
  if (k === "confirmed") return "#10B981";
  if (i >= 4) return "#0EA5E9";
  if (i >= 1) return "#F59E0B";
  return "#98A2B3";
};

export const SIGNALER = [
  { k: "yes", label: "Ja", farge: "#10B981" },
  { k: "maybe", label: "Kanskje", farge: "#D97706" },
  { k: "no", label: "Nei", farge: "#DC2626" },
];
export const SIGNAL_MAP = Object.fromEntries(SIGNALER.map((s) => [s.k, s]));

export function datoIdag() {
  const d = new Date();
  const p = (x) => String(x).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

export function dagerSiden(dato) {
  if (!dato) return null;
  const d = new Date(`${dato}T00:00:00`);
  const naa = new Date();
  naa.setHours(0, 0, 0, 0);
  return Math.round((naa - d) / 86400000);
}

export function fmtSiden(dato) {
  const d = dagerSiden(dato);
  if (d == null) return "";
  if (d <= 0) return "i dag";
  if (d === 1) return "i går";
  return `${d} d siden`;
}

const MND_KORT = ["jan", "feb", "mar", "apr", "mai", "jun", "jul", "aug", "sep", "okt", "nov", "des"];
export function fmtKortDato(dato) {
  if (!dato) return "";
  const [, m, d] = dato.split("-");
  return `${Number(d)}. ${MND_KORT[Number(m) - 1]}`;
}

export function datoOmDager(dager) {
  const d = new Date();
  d.setDate(d.getDate() + dager);
  const p = (x) => String(x).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

export const FORMATER = [
  { k: "keynote", label: "Keynote" },
  { k: "fireside", label: "Fireside" },
  { k: "panel", label: "Panel" },
  { k: "talk", label: "Talk" },
  { k: "debate", label: "Debatt" },
  { k: "workshop", label: "Workshop" },
  { k: "break", label: "Pause" },
  { k: "networking", label: "Networking" },
  { k: "other", label: "Annet" },
];
export const FORMAT_LABEL = Object.fromEntries(FORMATER.map((f) => [f.k, f.label]));

export const SESSION_STATUS = [
  { k: "draft", label: "Utkast", dot: "#98A2B3" },
  { k: "hold", label: "Hold", dot: "#F59E0B" },
  { k: "confirmed", label: "Bekreftet", dot: "#0EA5E9" },
  { k: "scheduled", label: "Planlagt", dot: "#10B981" },
];
export const SSTATUS = Object.fromEntries(SESSION_STATUS.map((s) => [s.k, s]));

export const SPACE_TYPES = [
  { k: "main_stage", label: "Hovedscene" },
  { k: "breakout", label: "Breakout" },
  { k: "expo", label: "Expo" },
  { k: "networking", label: "Networking" },
  { k: "backstage", label: "Backstage" },
  { k: "dinner", label: "Middag" },
  { k: "other", label: "Annet" },
];

export const tidTilMin = (t) => {
  if (!t || !/^\d{2}:\d{2}$/.test(t)) return null;
  return Number(t.slice(0, 2)) * 60 + Number(t.slice(3));
};

export const readyFarge = (pct, blockers) => {
  if (blockers > 0) return "#DC2626";
  if (pct >= 100) return "#10B981";
  if (pct >= 60) return "#0EA5E9";
  return "#F59E0B";
};

export const SPONSOR_STAGES = [
  { k: "researching", label: "Researching" },
  { k: "ready", label: "Ready to contact" },
  { k: "outreach_sent", label: "Outreach sent" },
  { k: "waiting", label: "Waiting" },
  { k: "dialogue", label: "Dialogue" },
  { k: "interested", label: "Interested" },
  { k: "confirmed", label: "Confirmed" },
  { k: "declined", label: "Declined" },
];
export const SPONSOR_STAGE_LABEL = Object.fromEntries(SPONSOR_STAGES.map((s) => [s.k, s.label]));

export const sponsorStageFarge = (k) => {
  if (k === "declined") return "#DC2626";
  if (k === "confirmed") return "#10B981";
  if (k === "dialogue" || k === "interested") return "#0EA5E9";
  if (k === "ready" || k === "outreach_sent" || k === "waiting") return "#F59E0B";
  return "#98A2B3";
};

export const TIERS = [
  { k: "founding", label: "Founding" },
  { k: "gold", label: "Gold" },
  { k: "silver", label: "Silver" },
  { k: "community", label: "Community" },
];
export const TIER_LABEL = Object.fromEntries(TIERS.map((t) => [t.k, t.label]));

export const EXP_TYPES = [
  { k: "expo", label: "Expo" },
  { k: "networking", label: "Networking" },
  { k: "dinner", label: "Middag" },
  { k: "reception", label: "Mottakelse" },
  { k: "demo", label: "Demo" },
  { k: "lounge", label: "Lounge" },
  { k: "hospitality", label: "Hospitality" },
  { k: "side_event", label: "Side event" },
  { k: "other", label: "Annet" },
];
export const EXP_TYPE_LABEL = Object.fromEntries(EXP_TYPES.map((t) => [t.k, t.label]));

export const EXP_STATUS = [
  { k: "idea", label: "Idé", dot: "#98A2B3" },
  { k: "planned", label: "Planlagt", dot: "#F59E0B" },
  { k: "confirmed", label: "Bekreftet", dot: "#10B981" },
];
export const EXP_STATUS_LABEL = Object.fromEntries(EXP_STATUS.map((s) => [s.k, s.label]));

export const TARGET_TIERS = [
  { k: "X", label: "Tier X", sub: "Definerende navn" },
  { k: "A", label: "Tier A", sub: "Sterke internasjonale/nordiske" },
  { k: "B", label: "Tier B", sub: "Solide og oppnåelige" },
];

export const TARGET_STATUS = [
  { k: "not_contacted", label: "Ikke kontaktet", dot: "#98A2B3" },
  { k: "researching", label: "Kartlegges", dot: "#8B5CF6" },
  { k: "intro_requested", label: "Intro forespurt", dot: "#F59E0B" },
  { k: "contacted", label: "Kontaktet", dot: "#0EA5E9" },
  { k: "declined", label: "Avslått", dot: "#DC2626" },
  { k: "converted", label: "Konvertert", dot: "#10B981" },
];

export const tierFarge = (k) => ({ X: "#B8860B", A: "#0EA5E9", B: "#98A2B3" }[k] || "#98A2B3");
